import { render, staticRenderFns } from "./AddSeniorCompany.vue?vue&type=template&id=9e085846&scoped=true"
import script from "./AddSeniorCompany.vue?vue&type=script&lang=js"
export * from "./AddSeniorCompany.vue?vue&type=script&lang=js"
import style0 from "./AddSeniorCompany.vue?vue&type=style&index=0&id=9e085846&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e085846",
  null
  
)

export default component.exports